import React from "react";
import moment from "moment";
import Title from "../common/Title";
import "./index.scss";
import ResumeItem from "./Item";

const Resume = () => {
  return (
    <div className="page" id="resume">
      <Title icon={"fa fa-briefcase"}>
        Resume - Total Commercial Experience{" "}
        {moment().diff("1/12/2012", "years", true).toFixed(2)} years
      </Title>
      <ResumeItem
        date={"July 2021 - Present"}
        title={"Tech Lead"}
        company={"Hydrasoft Technologies Private Limited"}
        logo={
          "http://www.thehydrasoft.com/wp-content/uploads/2022/01/cropped-cropped-hydrasoft-logo-final.png"
        }
      >
        • Work on front-end with extensive use of React Js and React native for
        developing SPA and app <br />• To create robust application architecture
        for front-end, integration of web api, maintenance of already developed
        projects.
      </ResumeItem>
      <ResumeItem
        date={"July 2017 - Jan 2021"}
        title={"Technical Consultant"}
        company={"Aarm Technologies"}
        logo={"https://aarmtechnologies.com/img/Aam02.png"}
      >
        • Work on front-end with extensive use of React Js and React native for
        developing SPA and app <br />
        • Continuous implementation and integration of new features on the main
        user-facing product's frontend.
        <br />• Ensuring seamless integration of the Angular frontend with the
        Django backend.
        <br />• Increasing Page load speeds by using lazy loading, server-side
        rendering, and bundle splitting. On boarding of new frontend engineers.
        <br />• Working closest with the Lead designer and ensuring easy
        handoffs of prototypes, mock-ups.
      </ResumeItem>
      <ResumeItem
        date={"Aug 2015 – May 2017"}
        title={"Sr. Software Developer"}
        company={"P P Bafna Venture Pvt Ltd"}
        logo={"http://www.bafnagroup.com/templates/bt_business/images/logo.png"}
      >
        • Develop custom reports from databases to extract and collect data
        using complicated SQL code with complex joins.
        <br />
        •Create necessary SQL views and advanced stored procedures. Responsible
        for timely implementation of data requests and provide a high level of
        service to all internal and external users.
      </ResumeItem>
      <ResumeItem
        date={"Mar 2014 – May 2015"}
        title={"Sr. Software Developer"}
        company={"Megabyte Infotech Solutions"}
        logo={
          "https://www.salestrendz.com/wp-content/webp-express/webp-images/doc-root/wp-content/uploads/2019/03/logofsdfd.png.webp"
        }
      >
        • Ability to handle multiple client calls and emails, creating new
        formula escalating when needed Other duties as assigned by management.{" "}
        <br />
        • Allocates budgets branded software packages and programs and
        recommends other organizational IT purchases and procurements.
        <br />
        • Document and follow-up of customer suggestions for continued
        improvements to internal systems and products.
        <br /> • Implementing Network & software Application & Antivirus server.
        <br />
        • Managing client software issue via phone & remote support.
        <br /> • Managing IT- support team. Solve Software upgrade & solving
        database error.
        <br />• Expertise in Requirement analysis and system specifications.
        Querying the Database using MS SQL Server 2005 to check out Successful
        transactions, reporting and prioritizing software according to the
        severity.
        <br />• Querying the Database using MS SQL Server 2008. <br />
        • Worked the backend by using Node JS, Express and Mongo DB <br />
      </ResumeItem>
      <ResumeItem
        classNames={"not-last"}
        date={"Dec 2012 – Apr 2014"}
        title={"Jr. Software Developer"}
        company={"EON DOT COM"}
        logo={"http://eondotcom.com/images/logo.png"}
      >
        • Managing User profiles, permissions and applying group policy on
        servers
        <br />
        • Administration of Network Printers and Local printers <br />
        • Customize Web Report Using Procedure,SQL query,Maintained in asp.net
        (Report, Analyticss) <br />
      </ResumeItem>
      <Title icon={"fa fa-university"}>Education</Title>
      <ResumeItem
        date={"2009 – 2012"}
        title={"Gujarat Technological University"}
        company={"Education"}
        logo={
          "https://www.igauge.in/admin/uploaded/rating/logo/GujaratTechnologicalUniversityLogo_1603367776.png"
        }
      >
        Master Degree in Software Engineering
      </ResumeItem>
    </div>
  );
};

export default Resume;
